export default "__VITE_PUBLIC_ASSET__5b6e9269__"